import { Box } from "@mui/material";
import { Loading } from "./Loading";

export function LoadingPage() {
    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Loading />
        </Box>
    );
}
